// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Menu } from 'antd'
import { CameraOutlined, UploadOutlined } from '@ant-design/icons'
import { withRouter } from 'react-router-dom'
import { parentRoutes, privateRoutes } from '../../routes'
import './nav.less'
import isDev from '../../utils/env'

function getOpenSubMenuKey (location) {
  const target = privateRoutes.find(item => item.path === location.pathname)
  const key = target?.parentID || ''
  return key
}

class Nav extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedKey: [props.location.pathname],
      openKeys: [getOpenSubMenuKey(props.location)],
      prevPath: props.location.pathname
    }
  }

  static getDerivedStateFromProps (nextProps, prevState) {
    const { prevPath } = prevState
    const newState = {}
    if (nextProps.location.pathname !== prevPath) {
      newState.openKeys = [getOpenSubMenuKey(nextProps.location)]
      newState.selectedKey = [nextProps.location.pathname]
      newState.prevPath = nextProps.location.pathname
    }
    return {
      ...prevState,
      ...newState
    }
  }

  handleMenuClick = (event) => {
    const { item, key } = event
    this.setState(
      {
        selectedKey: key
      },
      () => {
        this.props.history.push(key)
      }
    )
  }

  handleSubMenuOpenChange = openKeys => {
    const { collapsed } = this.props
    if (!collapsed) {
      this.setState({
        openKeys
      })
    }
  }

  render () {
    return (
      <div className='nav'>
        <Menu
          mode='inline'
          className='nav-menu'
          onClick={this.handleMenuClick}
          openKeys={this.state.openKeys}
          selectedKeys={this.state.selectedKey}
          onOpenChange={this.handleSubMenuOpenChange}
        >
          {
            parentRoutes.map(item => (
              <Menu.SubMenu key={item.parentID} title={item.parent} icon={item.icon}>
                {privateRoutes
                  .filter(route => route.parentID && route.parentID === item.parentID && (!route.hideOnProd || isDev()))
                  .map((route, index) => (
                    <Menu.Item key={route.path}>
                      {route.name}
                    </Menu.Item>
                  ))
                }
              </Menu.SubMenu>
            ))
          }
        </Menu>
      </div>
    )
  }
}

export default withRouter(Nav)
